import {Component, OnDestroy, OnInit} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {ModalService} from 'src/app/shared/services/modal.service';
import {ApiService} from 'src/app/shared/services/api.service';
import {UtilsService} from 'src/app/shared/services/utils.service';

import {banners, introSlider} from '../data';
import {environment} from '../../../../environments/environment';
import {SearchService} from '../../../shared/services/search.service';
import { DataService } from 'src/app/shared/services/data.service';
import { StoreService } from 'src/app/core/store/store.service';

@Component({
    selector: 'indiapicture-video',
    templateUrl: './video.component.html',
    styleUrls: ['./video.component.scss']
})

export class VideoComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();

    products = [];
    posts = [];
    loaded = false;
    introSlider = introSlider;
    banners = banners;
    // brandSlider = brandSlider;
    showbanner = environment.showBanner;
    headerType: string = environment.headerType;
    showVideo = 0;
    isMobile = false;
    currentUser:any = null;


    constructor(public apiService: ApiService, public utilsService: UtilsService,
                private modalService: ModalService, private searchService: SearchService,
            private dataService: DataService, private storageService: StoreService) {
        this.searchService = SearchService.getInstance();
        this.searchService.setSearch('');
        this.searchService.setCategory('creative-videos');
    }

    showModal(event: Event) {
        event.preventDefault();
        this.modalService.showVideoModal(event.currentTarget['href']);
    }

    ngOnInit(): void {
        if (window.innerWidth <= 500) {
            this.isMobile = true;
        }
        this.getCurrentUser();

    }

    showLargeVideo(event: MouseEvent) {
        event.preventDefault();
        this.showVideo = 1;
    }

    getCurrentUser() {
        this.dataService.currentData$
            .pipe(takeUntil(this.destroy$))
            .subscribe((data:any) => {
         //  console.log('index component', data);
        //  console.log('DataService currentData$ subscription triggered with data:', data);
            if (data) {
            this.currentUser = data;
            }else{
                const user = this.storageService.getItem('currentUser');
             //  console.log('StorageService ==>', user);
                if (user) {
                    // console.log('User data found in StorageService:', user);
                 //  console.log('currentUser ==> ', user);
                    this.currentUser = user;
                }else{
                    // console.log('No user data found in DataService or StorageService');
                    this.currentUser = null;
                }
            }
            // console.log('currentUser ==> ', this.currentUser);
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
